import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { Spin } from 'antd';
import { authAPI } from '../services/api';

// 受保护的路由组件
const ProtectedRoute = ({ children }) => {
  const [loading, setLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  
  useEffect(() => {
    const checkAuth = async () => {
      try {
        // 检查是否有令牌
        if (!authAPI.isLoggedIn()) {
          setIsAuthenticated(false);
          setLoading(false);
          return;
        }
        
        // 验证令牌有效性
        const response = await authAPI.verifyToken();
        
        if (response.success) {
          setIsAuthenticated(true);
        } else {
          // 令牌无效，清除本地存储
          authAPI.logout();
          setIsAuthenticated(false);
        }
      } catch (error) {
        console.error('认证验证失败:', error);
        // 出错时清除令牌
        authAPI.logout();
        setIsAuthenticated(false);
      } finally {
        setLoading(false);
      }
    };
    
    checkAuth();
  }, []);
  
  // 加载中
  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh' 
      }}>
        <Spin size="large" tip="验证身份..." />
      </div>
    );
  }
  
  // 未登录，重定向到登录页面
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  
  // 已登录，渲染子组件
  return children;
};

export default ProtectedRoute; 